import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Shield, Mail, Phone, Send } from "lucide-react";
import StickyNavigation from "@/components/layout/StickyNavigation";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { isRootDomain, getImageUrl } from "@/lib/utils";

const TermsAndConditions = () => {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription:', email);
    setEmail("");
  };

  const subMatch = window.location.pathname.match(/^(?:\/business)?\/site\/([^/]+)/);
  const subPrefix = subMatch ? `/site/${subMatch[1]}` : '';
  const tLink = (path: string) => `${subPrefix}${path}`;

  // Footer logo size: 70% of navbar logo (context-aware)
  const isMainSite = isRootDomain();
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const hostSub = host.split('.')[0] || '';
  const pathIsIncorpify = typeof window !== 'undefined' && /(?:^|\/)site\/incorpify-ai(?:\/|$)/.test(window.location.pathname);
  const isIncorpifyAI = (hostSub === 'incorpify-ai') || pathIsIncorpify;
  const footerLogoDesktop = isMainSite ? 'h-[8.4rem]' : (isIncorpifyAI ? 'h-[8.064rem]' : 'h-[4.2rem]');
  const footerLogoMobile  = isMainSite ? 'h-24' : (isIncorpifyAI ? 'h-[6.048rem]' : 'h-[3.36rem]');


  return (
    <div className="min-h-screen bg-white">
      <StickyNavigation />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center">
              <Shield className="h-8 w-8 text-white" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Terms & Conditions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Please read these terms and conditions carefully before using our services.
          </p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>1) Acceptance The Use Of yallacompare.com Terms and Conditions</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700">
                  Your access to and use of yallacompare.com is subject exclusively to these Terms and Conditions. You will not use the Website for any purpose that is unlawful or prohibited by these Terms and Conditions. By using the Website you are fully accepting the terms, conditions and disclaimers contained in this notice. If you do not accept these Terms and Conditions you must immediately stop using the Website.
                </p>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>2) Credit card details</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 mb-4">
                  yallacompare.com will never ask for Credit Card details and request that you do not enter it on any of the forms on yallacompare.com.
                </p>
                <p className="text-gray-700">
                  Instead, any payments will be directed to a secure page hosted by our PCI compliant payment gateway, checkout.com. Or for some policies, payment will be directed to the insurance company's payment page.
                </p>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>3) Change of Use</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 mb-4">yallacompare.com reserves the right to:</p>
                <div className="ml-4">
                  <p className="text-gray-700 mb-2">
                    <strong>3.1)</strong> change or remove (temporarily or permanently) the Website or any part of it without notice and you confirm that yallacompare.com shall not be liable to you for any such change or removal and.
                  </p>
                  <p className="text-gray-700">
                    <strong>3.2)</strong> change these Terms and Conditions at any time, and your continued use of the Website following any changes shall be deemed to be your acceptance of such change.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>4) Links to Third Party Websites</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700">
                  yallacompare.com Website may include links to third party websites that are controlled and maintained by others. Any link to other websites is not an endorsement of such websites and you acknowledge and agree that we are not responsible for the content or availability of any such sites.
                </p>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>5) Copyright</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <p className="text-gray-700">
                    <strong>5.1)</strong> All copyright, trademarks and all other intellectual property rights in the Website and its content (including without limitation the Website design, text, graphics and all software and source codes connected with the Website) are owned by or licensed to yallacompare.com or otherwise used by yallacompare.com as permitted by law.
                  </p>
                  <p className="text-gray-700">
                    <strong>5.2)</strong> In accessing the Website you agree that you will access the content solely for your personal, non-commercial use. None of the content may be downloaded, copied, reproduced, transmitted, stored, sold or distributed without the prior written consent of the copyright holder. This excludes the downloading, copying and/or printing of pages of the Website for personal, non-commercial home use only.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>6) Disclaimers and Limitation of Liability</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <p className="text-gray-700">
                    <strong>6.1)</strong> The Website is provided on an AS IS and AS AVAILABLE basis without any representation or endorsement made and without warranty of any kind whether express or implied, including but not limited to the implied warranties of satisfactory quality, fitness for a particular purpose, non-infringement, compatibility, security and accuracy.
                  </p>
                  <p className="text-gray-700">
                    <strong>6.2)</strong> To the extent permitted by law, yallacompare.com will not be liable for any indirect or consequential loss or damage whatever (including without limitation loss of business, opportunity, data, profits) arising out of or in connection with the use of the Website.
                  </p>
                  <p className="text-gray-700">
                    <strong>6.3)</strong> yallacompare.com makes no warranty that the functionality of the Website will be uninterrupted or error free, that defects will be corrected or that the Website or the server that makes it available are free of viruses or anything else which may be harmful or destructive.
                  </p>
                  <p className="text-gray-700">
                    <strong>6.4)</strong> Nothing in these Terms and Conditions shall be construed so as to exclude or limit the liability of yallacompare.com for death or personal injury as a result of the negligence of yallacompare.com or that of its employees or agents.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>7) Indemnity</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700">
                  You agree to indemnify and hold yallacompare.com and its employees and agents harmless from and against all liabilities, legal fees, damages, losses, costs and other expenses in relation to any claims or actions brought against yallacompare.com arising out of any breach by you of these Terms and Conditions or other liabilities arising out of your use of this Website.
                </p>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>8) Severance</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700">
                  If any of these Terms and Conditions should be determined to be invalid, illegal or unenforceable for any reason by any court of competent jurisdiction then such Term or Condition shall be severed and the remaining Terms and Conditions shall survive and remain in full force and effect and continue to be binding and enforceable.
                </p>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>9) Refunds</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <p className="text-gray-700">
                    Refunds will be done only through the Original Mode of Payment. In the event that transaction error has occurred while making the payment, a refund in most cases will be issued to the same credit card you used for the original purchase.
                  </p>
                  <p className="text-gray-700">
                    Once processed, the customer's bank will determine how long before the refunded amount reflects in the account, this can be up to 14 days for some banks.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="mb-8">
              <CardHeader>
                <CardTitle>10) Cancellations</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <p className="text-gray-700">
                    In case of policy cancellation, the discounted amount would not be refunded. If a customer has made any claim on the policy, then he/she would not be eligible for any refund.
                  </p>
                  <p className="text-gray-700">
                    Refunds will be calculated according to the concerned insurance company's policy, and not by yallacompare.
                  </p>
                </div>
              </CardContent>
            </Card>

          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="bg-gradient-to-br from-gray-50 to-blue-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-2xl font-bold mb-2">Stay in Touch</h3>
          <p className="text-gray-600 mb-6">Subscribe to our newsletter and stay updated.</p>

          <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1"
            />
            <Button type="submit" style={{ backgroundColor: '#da1884' }} className="text-white">
              <Send className="h-4 w-4 mr-2" />
              Subscribe
            </Button>
          </form>
        </div>
      </section>

      {/* Footer - tenant-aware */}
      <footer className="bg-white text-gray-900 py-12 border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <div className="flex items-center justify-center mb-4">
              <Link to={tLink('/')} className="flex items-center">
                <img
                  src={(tenant?.logoUrl) || getImageUrl("yallacompare-for-business-logo.png")}
                  alt={tenant?.name || "Yallacompare for Business"}
                  className={`w-auto object-contain ${footerLogoMobile} sm:${footerLogoDesktop}`}
                />
              </Link>
            </div>

            <p className="text-gray-600 max-w-2xl mx-auto">
              Yallacompare.com is the leading finance comparison site in the Middle East.
            </p>

            <div className="flex justify-center items-center space-x-6">
              <a href="tel:+971456221000" className="flex items-center text-blue-600 hover:text-blue-700">
                <Phone className="h-4 w-4 mr-2" />
                +971 45 622 100
              </a>
            </div>

            <div className="text-sm text-gray-500 space-y-2 max-w-4xl mx-auto">
              <p>Information found on yallacompare is provided for illustrative purposes only, rates are subject to change based on your personal circumstances.</p>
              <p>You should always speak to a trained professional before taking out any form of finance.</p>
              <p>Implications of non-payment: If you fail to keep up with repayments on your finance, your bank may file a report with the UAE credit rating agency which may impact your ability to borrow from UAE banks in the future.</p>
              <p className="font-semibold">YOUR HOME MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON A MORTGAGE, LOAN OR ANY OTHER DEBT SECURED ON IT.</p>
              <p>Insurance is provided by Yallacompare Insurance Broker LLC (formerly Gulf Resources Insurance Management Services Limited), an Insurance Broker regulated by the UAE Central Bank (registration #20).</p>
            </div>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">© 2025 yallacompare. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
